import angular from 'angular';
import IFormattedStepSchema from '@Angular.Runner/interfaces/IFormattedStepSchema';
import { Services } from '@Shared.Angular/@types/services';

angular.module('fg').controller('fgSchemaController', [
  'fgUtils',
  '$timeout',
  'pubsubService',
  'flowinglyConstants',
  'APP_CONFIG',
  'flowinglyModelUtilityService',
  function (
    fgUtils,
    $timeout,
    pubsubService,
    flowinglyConstants,
    appConfig,
    flowinglyModelUtilityService: Services.FlowinglyModelUtilityService
  ) {
    let _model: IFormattedStepSchema;

    this.model = function (value: IFormattedStepSchema) {
      if (value !== undefined) {
        _model = value;

        if (!angular.isArray(value.fields)) {
          value.fields = [];
        }
        if (appConfig.enableHiddenLookupField) {
          value.fields.forEach((field) => {
            if (
              field.type === flowinglyConstants.formFieldType.LOOKUP &&
              field.displayInCompletedSteps == null
            ) {
              field.displayInCompletedSteps = true;
            }
          });
        }
      }
      return _model;
    };

    this.addField = function (field, index, needScroll) {
      collapseFields();
      const copy = fgUtils.copyField(field);
      copy.displayProperties = true;
      let instructionFieldsCache;
      if (field.type === flowinglyConstants.formFieldType.INSTRUCTION) {
        // default to true, FLOW-2418 Given an instruction text is added to a form, Display Instruction text in completed steps in Runner + Visibility icon will default to on
        copy.displayInCompletedSteps = true;
        if (!instructionFieldsCache) {
          instructionFieldsCache = (_model.fields || []).filter(
            (x) => x.type === flowinglyConstants.formFieldType.INSTRUCTION
          );
        }
        copy.displayName =
          flowinglyModelUtilityService.generateUniqueDisplayName(
            flowinglyConstants.formFieldDisplayName.INSTRUCTION,
            instructionFieldsCache,
            (f) => (f.displayName || '').trim()
          );
      }

      if (
        field.type === flowinglyConstants.formFieldType.ATTACH_DOCUMENT ||
        field.type === flowinglyConstants.formFieldType.PROCEDURE
      ) {
        // FLOW-5012 - default to false
        copy.displayInCompletedSteps = false;
      }

      if (
        field.type === flowinglyConstants.formFieldType.LOOKUP &&
        appConfig.enableHiddenLookupField
      ) {
        copy.displayInCompletedSteps = true;
      }

      if (field.type === flowinglyConstants.formFieldType.ADDRESS) {
        copy.displayInCompletedSteps = true;
        copy.addressProviderId = null;
      }

      index = index === undefined ? _model.fields.length : index;
      _model.fields.splice(index, 0, copy);
      if (needScroll) {
        $timeout(function () {
          const newField = angular.element('#' + copy.name);
          const fieldContainer = angular.element('#fieldContainer');

          // don't scroll if only one field
          if (newField && fieldContainer && _model.fields.length > 1) {
            fieldContainer[0].scrollTop =
              fieldContainer[0].scrollHeight - newField.height() - 120;
          }
        });
      }
    };

    this.removeField = function (index) {
      _model.fields.splice(index, 1);
      pubsubService.publish(
        'WORKFLOW_DESIGNER_FORM_FIELDS_CHANGED',
        'fgSchemaController'
      );
    };

    this.swapFields = function (fromIndex, toIndex) {
      const fields = _model.fields;
      const fieldLength = _model.fields.filter(
        (x) => x.type !== flowinglyConstants.formFieldType.RECAPTCHA
      ).length;
      if (
        fromIndex < 0 ||
        fromIndex >= fieldLength ||
        toIndex < 0 ||
        toIndex >= fieldLength ||
        fromIndex === toIndex
      ) {
        return;
      }

      const movingField = fields[fromIndex];
      fields[fromIndex] = angular.copy(fields[toIndex]);
      fields[toIndex] = movingField;
    };

    this.moveField = function (fromIndex, toIndex) {
      const fields = _model.fields;
      if (toIndex > fromIndex) {
        --toIndex;
      }
      if (
        fromIndex < 0 ||
        fromIndex >= fields.length ||
        toIndex < 0 ||
        toIndex >= fields.length ||
        fromIndex === toIndex
      ) {
        return;
      }
      const indexChange = toIndex > fromIndex ? 1 : -1;
      const movingField = fields[fromIndex];
      for (
        let currentIndex = fromIndex;
        currentIndex !== toIndex;
        currentIndex += indexChange
      ) {
        fields[currentIndex] = angular.copy(fields[currentIndex + indexChange]);
      }
      fields[toIndex] = movingField;
    };

    function collapseFields() {
      (_model.fields || []).forEach((field) => {
        field.displayProperties = false;
        if (field.type === 'image' && (!field.value || field.disabled)) {
          field.minimized = true;
        }
      });
    }
  }
]);
